import Backbone from "backbone";
import Model from "nexia_mobile/framework/model";
import Resource from "nexia_mobile/framework/resource";
import Url from "nexia_mobile/url";
import followLink from "nexia_mobile/models/followLink";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import formatServerErrors from "nexia_mobile/formatServerErrors";
import { getLanguageSet } from "nx-components/Locales";

class BaseModel extends Model {
  constructor(...args) {
    super(...args);
    this.listenTo(this, "error", this._handleServerError);
  }

  onParse(rawAttrs) {
    let attrs = super.onParse(rawAttrs);
    if (attrs.result) {
      attrs = attrs.result;
    }
    return _.extend(attrs, this.parseLinks(attrs));
  }

  onParseError(rawAttrs) {
    const localeSet = getLanguageSet();
    const language = localeSet.nexia_mobile.utils.ajax_hooks;
    let attrs = rawAttrs || {};
    // support the mishmash of error formats our server returns
    if (attrs.error) {
      attrs = attrs.error;
    }
    if (attrs.options) {
      attrs = attrs.options;
    } // backstage errors

    if (attrs.errors) {
      return formatServerErrors(attrs.errors, attrs);
    }
    if (attrs.message) {
      return [{ errorMessage: attrs.message }];
    }
    return [{ errorMessage: language.unkownError }];
  }

  validateAttribute(attribute) {
    return this.validate(this.attributes, {
      validate: true,
      validateOnly: attribute,
    });
  }

  trigger(...args) {
    super.trigger(...args);
    // only broadcast the event if we were the originator.
    // otherwise events bubbled up from nested models/collections will get repeated
    if (args[1] === this) {
      BaseModel.Events.trigger(...args);
    }
  }

  postCommand(name, options = {}) {
    const link = {
      href: Url.withAdditionalPath(this.url(), name),
      method: options.method || "POST",
    };
    return followLink(this, link, options);
  }

  _translateArrayOfErrors(errors) {
    let result = [];
    errors.forEach((error) => {
      let translatedError = { errorMessage: error.errorMessage };
      if (error.attribute) {
        translatedError.attribute = error.attribute;
      }
      result.push(translatedError);
    });
    return result;
  }

  _handleServerError(model, xhr) {
    if (!xhr || !_.isFunction(xhr.getResponseHeader)) {
      console.warn(
        "We expect backbone error events to have" +
          " the jqXHR as their second parameter.",
        new Error().stack
      );
    }
    if (xhr.statusText === "abort") {
      // an aborted request still calls the error handlers, but we shouldn't handle it and show a toast
      return;
    }

    let response;
    try {
      response = JSON.parse(xhr.responseText);
    } catch (error) {
      response = {};
    }

    //HACK: Nexia api will always return a 500 error after account creation. Cannot be resolved. Ignore the error.
    if (model.id.match(/signup_validation/)) {
      return;
    }
    // derived models specify how the error is parsed
    let errors = this.onParseError(response);
    if (!_.isEmpty(errors)) {
      Dispatch(
        "SERVERSIDE_ERROR_OCCURRED",
        this._translateArrayOfErrors(errors)
      );
    }
  }
}

BaseModel.Events = _.extend({}, Backbone.Events);
_.extend(BaseModel.prototype, Resource, {
  url() {
    return (
      this.getUrl() || (this.collection ? this.collection.url() : undefined)
    );
  },
});

export default BaseModel;



// WEBPACK FOOTER //
// ./src/models/base_model.js